import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import TaxDetailsCopy from './TaxDetailsCopy';
import GuestTaxDetailsCopy from './GuestTaxDetailsCopy';
import { filter, includes } from 'lodash';
import TaxRegistrationForm from './TaxRegistrationForm';
import {
  intlTaxTypeAddDetails,
  intlTaxTypeUpdateDetails,
  intlTaxTypeRegistrationDetails
} from '../data/translationsData';

class AddTaxDetails extends Component {
  constructor (props) {
    super(props);
  }

  render () {
    const {
      allCountries, address, orderedAddressFields, countryData,
      globalCountries = [],
      intlTranslationsKey, federalVatProfile, subRegionVatProfile, profile, isHost, isEdit
    } = this.props;

    let addressLine1;
    let addressLine2;

    if (address && orderedAddressFields) {
      const { country, state } = address;

      if (orderedAddressFields[2]) {
        addressLine1 = orderedAddressFields[2] + (orderedAddressFields[3] ? ` ${orderedAddressFields[3]}` : '');

        // some customization for AU, CA and US to display shortened state/provinces eg. California -> CA
        if (includes(['CA', 'US', 'AU'], country)) {
          const zone = filter(countryData.zones, { code: state })[0];
          const { name, code } = zone;
          addressLine2 = orderedAddressFields[4].replace(name, code) + ', ' + orderedAddressFields[5];
        } if ('GB' === country) {
          addressLine2 = `${orderedAddressFields[4]}, ${orderedAddressFields[5]}, ${orderedAddressFields[6]}`;
        } else {
          addressLine2 = orderedAddressFields[4] + ', ' + orderedAddressFields[5];
        }
      // if user only has country on billing address, only display country on CTA banner (except Canada)
      } else {
        if ('CA' === country) {
          addressLine1 = orderedAddressFields[4] + ', ' + orderedAddressFields[5];
        } if ('GB' === country) {
          addressLine1 = orderedAddressFields[6];
        } else {
          addressLine1 = orderedAddressFields[5];
        }
        addressLine2 = '';
      }
    }

    const headingText = isEdit ? intlTaxTypeUpdateDetails[intlTranslationsKey] :
      intlTaxTypeAddDetails[intlTranslationsKey];

    return (
      <div className="AddTaxDetails ps-container-lg-margin ps-container-fixed">
        <div className="ps-row">
          <div className="col-sm-12 col-md-9 col-lg-8 col-xxl-6">
            <h4 className="heading">
              {headingText && <FormattedMessage { ...headingText } />}
            </h4>

            { isHost ? <TaxDetailsCopy /> : <GuestTaxDetailsCopy /> }

            <h5 className="margin-xl-top margin-xl-bottom">
              {intlTaxTypeRegistrationDetails[intlTranslationsKey] && <FormattedMessage { ...intlTaxTypeRegistrationDetails[intlTranslationsKey] } />}
            </h5>
            <TaxRegistrationForm
              {...this.props}
              addressLine1={addressLine1}
              addressLine2={addressLine2}
              isHost={isHost}
            />
          </div>
        </div>
      </div>
    );
  }
}

AddTaxDetails.propTypes = {
  fee_profiles: PropTypes.object,
  allCountries: PropTypes.array,
  accessToken: PropTypes.string,
  orderedAddressFields: PropTypes.array,
  countryData: PropTypes.object,
  address: PropTypes.object,
  taxType: PropTypes.string
};

export default (injectIntl(AddTaxDetails));
